<template>
  <div style="width: 100%" :class="$gStyle('lh-grid gap-y-4')">
    <patternlib-headline
      :headline="$t('myAccount.personalData')"
      heading-tag="h3"
      separator="none"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    ></patternlib-headline>

    <patternlib-dropdown-v1
      :label="$t('myAccount.salutation.text')"
      :placeholder="$t('myAccount.salutation.placeholder')"
      id="salutation"
      :value="gender"
      :status="getStatus(gender)"
      @lhSelect="
        (e) => {
          gender = e.detail;
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-4 xl:col-span-5')"
    >
      <patternlib-option-v1
        value="male"
        :label="$t(`myAccount.salutation.male`)"
      ></patternlib-option-v1>
      <patternlib-option-v1
        value="female"
        :label="$t(`myAccount.salutation.female`)"
      ></patternlib-option-v1>
      <patternlib-option-v1
        value="neutral"
        :label="$t(`myAccount.salutation.neutral`)"
      ></patternlib-option-v1>
    </patternlib-dropdown-v1>

    <patternlib-textinput
      :label="$t('myAccount.titel')"
      :value="title"
      @lhChange="
        (e) => {
          if (e.detail.value.length <= 30) {
            title = e.detail.value;
          }
        }
      "
      :display="displayOnly"
      maxlength="30"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    />
    <patternlib-textinput
      :label="$t('myAccount.prename')"
      :value="firstname"
      :status="getStatus(firstname)"
      @lhChange="
        (e) => {
          firstname = e.detail.value;
          $emit('personalData:firstname', firstname);
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    />
    <patternlib-textinput
      :label="$t('myAccount.lastname')"
      :value="lastname"
      :status="getStatus(lastname)"
      @lhChange="
        (e) => {
          lastname = e.detail.value;
          $emit('personalData:lastname', lastname);
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    />

    <patternlib-textinput
      :label="$t('myAccount.street')"
      :value="street"
      :status="getStatus(street)"
      @lhChange="
        (e) => {
          street = e.detail.value;
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    />

    <patternlib-textinput
      :label="$t('myAccount.postalCode')"
      id="postalCode"
      :value="postalCode"
      :status="getStatus(postalCode)"
      @lhChange="
        (e) => {
          postalCode = e.detail.value;
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-2 xl:col-span-3')"
    />
    <patternlib-textinput
      :label="$t('myAccount.city')"
      :value="city"
      :status="getStatus(city)"
      @lhChange="
        (e) => {
          city = e.detail.value;
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-6 xl:col-span-7')"
    />

    <patternlib-dropdown-v1
      :label="$t('myAccount.land')"
      id="land"
      :value="currentCountryId"
      :status="getStatus(currentCountryId)"
      @lhSelect="
        (e) => {
          currentCountryId = e.detail;
        }
      "
      :display="displayOnly"
      filterable
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    >
      <patternlib-option-v1
        :value="country[0]"
        :label="country[1]"
        v-for="(country, index) in getSortedCountries()"
      />
    </patternlib-dropdown-v1>

    <patternlib-textinput
      :label="$t('myAccount.phoneNumber')"
      :info-text="$t('myAccount.phoneNumberInfo')"
      :value="phoneNumber"
      :status="getStatus(phoneNumber)"
      @lhChange="
        (e) => {
          phoneNumber = e.detail.value;
        }
      "
      :display="displayOnly"
      style="display: block"
      :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
    />
  </div>
</template>

<script>
  export default {
    data: () => ({
      gender: '',
      title: '',
      firstname: '',
      lastname: '',
      street: '',
      postalCode: '',
      city: '',
      currentCountryId: '',
      phoneNumber: '',

      showMissingFields: false,
      displayOnly: true
    }),

    methods: {
      getStatus(value) {
        if (!this.showMissingFields) {
          return 'default';
        }

        if (value) {
          return 'default';
        }
        return 'error';
      },

      getData() {
        let data = {
          // add all mandatory field
          gender: this.gender,
          firstname: this.firstname,
          lastname: this.lastname,
          streetAndNumber: this.street,
          postalCode: this.postalCode,
          city: this.city,
          countryId: this.currentCountryId,
          phoneNumber: this.phoneNumber
        };

        let values = Object.values(data);
        if (values.includes(null) || values.includes('')) {
          this.showMissingFields = true;
          return null;
        }

        data = {
          // add optional fields
          title: this.title,
          ...data
        };
        return data;
      },

      getSortedCountries() {
        let countries;
        if (!!this.$i18n.messages[this.$i18n.locale]) {
          countries = Object.entries(
            this.$i18n.messages[this.$i18n.locale].country
          );
        } else {
          countries = Object.entries(
            this.$i18n.messages[this.$i18n.fallbackLocale].country
          );
        }
        countries.sort((a, b) => {
          return a[1].localeCompare(b[1]);
        });
        return countries;
      }
    }
  };
</script>

<style lang="scss" scoped></style>
